<template>
  <div>
    <!-- <el-row>
      <h2>调拨入库</h2>
    </el-row> -->
    <!-- <el-row :gutter="20">
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" size="small">
          <el-form-item label="调拨日期：">
            <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
            <el-select filterable v-model="searchForm.STATUS" clearable placeholder="请选择">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <label slot="label">仓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;库：</label>
            <el-select filterable v-model="searchForm.DEST_GYS_ID" clearable placeholder="请选择">
              <el-option v-for="item in GYS_LIST" :key="item.DEST_GYS_ID" :label="item.NAME" :value="item.DEST_GYS_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button @click="search()" size="small">筛选</el-button>
        </el-form>
      </el-col>
    </el-row> -->
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-table :data="tableData" stripe border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="CREATE_TIME" label="调拨日期" min-width="50"></el-table-column>
          <el-table-column prop="SRC_PROJECT_NAME" label="调出仓库" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_COUNT" label="总数量" min-width="40"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总价值" min-width="40"></el-table-column>
          <el-table-column prop="STATUS" label="状态" min-width="60">
            <template slot-scope="scope">
              <el-tag>{{ showStatusLable(scope.row.STATUS) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" size="small" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" icon="el-icon-view" size="small" @click="submitAdjust(scope.row)"
                v-show="scope.row.STATUS === 1">确认</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
      layout="total,prev, pager, next, jumper" :total="total_count" style="float: right"></el-pagination>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  props: {
    searchForm1: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      searchForm: this.searchForm1,
      tableData: [],
      STATUS_LIST: ['已撤回', '未处理', '已同意'],
      statusList: [
        {
          label: '已撤回',
          value: '0',
        },
        {
          label: '未处理',
          value: '1',
        },
        {
          label: '已同意',
          value: '2',
        },
      ],
      GYS_LIST: [],
      pageSize: 10,
      currentPage: 1,
      total_count: 0,
    };
  },
  methods: {
    // 筛选按钮
    search() {
      this.currentPage = 1;
      this.queryEnterDocument();
    },
    // 判断状态
    showStatusLable(index) {
      return this.STATUS_LIST[index];
    },
    // 查看
    detail(row) {
      this.$router.push({
        path: `/adjust_enter_detail/${row.ID}`,
        params: { id: row.ID },
      });
      sessionStorage.setItem('status', row.STATUS);
    },
    // 确认
    submitAdjust(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10061',
            OTYPE: 8,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            TRANSFER_ID: row.ID,
          };
          http
            .post(params)
            .then((result) => {
              this.$message.show({ text: '确认成功', type: 'success' });
              this.queryEnterDocument();
              document.body.style.cursor = 'default';
            })
            .catch((err) => {
              this.$message.show({ text: err, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
        }
      }
    },
    // 切换分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryEnterDocument();
    },
    queryEnterDocument() {
      const params = {
        SERVICE_ID: '10061',
        OTYPE: 5,
        DEST_GYS_ID: sessionStorage.getItem('tcId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.DEST_GYS_ID) {
        params.SRC_GYS_ID = this.searchForm.DEST_GYS_ID;
      }
      if (this.searchForm.STATUS) {
        params.STATUS = this.searchForm.STATUS;
      }
      if (this.searchForm.DATE) {
        params.START_DAY = date(this.searchForm.DATE[0], '%F');
        params.END_DAY = date(this.searchForm.DATE[1], '%F');
      }
      http
        .post(params)
        .then((result) => {
          if (result[0]) {
            this.tableData = result[0].OP_ROLE;
            this.total_count = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.total_count = 0;
          }
        })
        .catch((err) => {
          this.$message.show({
            text: err,
            type: 'error',
          });
        });
    },
    async queryProject() {
      const params = {
        SERVICE_ID: '10061',
        OTYPE: 9,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      await http
        .post(params)
        .then((result) => {
          this.GYS_LIST = result;
          this.$emit('getGYSList', this.GYS_LIST);
        })
        .catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryEnterDocument();
    this.queryProject();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/adjust_enter.vue